<template>
  <v-list-item
    :href="href"
    :rel="href && href !== '#' ? 'noopener' : undefined"
    :target="item.target ? item.target : undefined"
    :to="item.to"
    :active-class="`active-item ${!isDark ? 'black' : 'white'}--text`"
  >
    <v-list-item-icon
      v-if="text"
      class="v-list-item__icon--text"
      v-text="computedText"
    />

    <v-list-item-avatar
      v-else-if="item.avatar"
      class="align-self-center"
      color="grey"
    >
      <img v-if="item.avatarPath" :src="item.avatarPath" />
    </v-list-item-avatar>

    <v-list-item-icon v-else-if="item.icon">
      <!-- <img
        v-if="item.to === '/zalo/list'"
        :width="20"
        :height="20"
        class="mr-2"
        src="../../../public/img/zalo.svg"/> -->

      <img
        v-if="item.to === '/zalo/list'"
        src = "../../../public/img/zalo.png"
        alt="Zalo" class="ml-1" style="width: 25px;height: 25px;vertical-align: middle;"
      />
      <v-icon v-else v-text="item.icon" />
    </v-list-item-icon>

    <v-list-item-content v-if="item.title || item.subtitle">
      <v-list-item-title v-text="item.title" />

      <v-list-item-subtitle v-text="item.subtitle" />
    </v-list-item-content>
  </v-list-item>
</template>

<script>
  import Themeable from 'vuetify/lib/mixins/themeable'

  export default {
    name: 'Item',

    mixins: [Themeable],

    props: {
      item: {
        type: Object,
        default: () => ({
          href: undefined,
          icon: undefined,
          subtitle: undefined,
          title: undefined,
          to: undefined,
          target: undefined,
        }),
      },
      text: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      computedText () {
        if (!this.item || !this.item.title) return ''

        let text = ''

        this.item.title.split(' ').forEach(val => {
          text += val.substring(0, 1)
        })

        return text
      },
      href () {
        return this.item.href || (!this.item.to ? '#' : undefined)
      },
    },
  }
</script>
<style lang="css" scoped>
.active-item {
  background: rgba(233, 233, 233, 0.22);
  color: #FFFFFF;
}
.v-list-item .v-list-item__title {
  /*font-weight: 500 !important;*/
}
.v-navigation-drawer .v-icon.v-icon {
  color: #FFFFFF !important;
}
.v-list-item .v-list-item__title {
  color: #FFFFFF !important;
}
</style>